import { ToastContainer as RtToastContainer, toast as RtToast } from 'react-toastify'
import { Container, TypoGraph } from 'components/ui'

export type ToastPosition = 'top-right' | 'top-center' | 'top-left' | 'bottom-right' | 'bottom-center' | 'bottom-left'
const defaultToastPosition: ToastPosition = 'bottom-right'
export const toastPositionStorageKey = 'factorcloud-notificationPosition'

export const loadToastPosition = () =>
  (localStorage.getItem(toastPositionStorageKey) as ToastPosition) || defaultToastPosition

type ToastContainerProps = {
  /** The position is an optional prop that determines the position of the toast container on the screen. The only possible value is "bottom-right".*/
  position?: ToastPosition
  /** The autoClose is an optional prop that determines the time in milliseconds after which the toast notification will automatically close. If set to false ,the notification will not automatically close.*/
  autoClose?: number | false

  closeOnClick?: boolean

  draggable?: boolean
}

export const ToastContainer = (props: ToastContainerProps) => {
  const {
    position = 'top-right',
    autoClose = 10000, // default autoclose is 5 sec
    closeOnClick = true,
    draggable = false,
  } = props
  return (
    <RtToastContainer
      position={position}
      autoClose={autoClose}
      hideProgressBar={true}
      newestOnTop={true}
      closeOnClick={closeOnClick}
      rtl={false}
      pauseOnFocusLoss
      draggable={draggable}
      pauseOnHover
    />
  )
}

type ToastContentProps = {
  title: string
  subTitle?: string
  customContent?: React.ReactNode
}

const ToastContent = (props: ToastContentProps) => {
  const { title, subTitle, customContent } = props
  return (
    <Container>
      <TypoGraph content={title} sx={{ textTransform: 'capitalize' }} />
      {subTitle && <TypoGraph variant="subtitle2" content={subTitle} />}
      {customContent && customContent}
    </Container>
  )
}

export type ToastProps = {
  type?: 'info' | 'success' | 'warning' | 'error'
  title?: string
  subTitle?: string
  autoClose?: number | false
  position?: ToastPosition
  theme?: 'light' | 'dark' | 'colored'
  showIcon?: boolean
  closeOnClick?: boolean
  draggable?: boolean
  customContent?: React.ReactNode
}

const ERROR_AUTO_CLOSE = 10000 // 10 seconds for error toasts
const SUCCESS_AUTO_CLOSE = 1000 // 1 seconds for success toasts
const WARNING_AUTO_CLOSE = 10000 // 7 seconds for warning toasts
const INFO_AUTO_CLOSE = 5000 // 5 seconds for info toasts

const Toast = (props: ToastProps) => {
  const {
    type = 'success',
    title = '',
    subTitle = '',
    theme = 'light',
    showIcon = true,
    closeOnClick = true,
    draggable = false,
    customContent,
    autoClose,
  } = props

  let defAutoClose = autoClose
  if (defAutoClose === undefined) {
    if (type === 'error') {
      defAutoClose = ERROR_AUTO_CLOSE
    } else if (type === 'info') {
      defAutoClose = INFO_AUTO_CLOSE
    } else if (type === 'warning') {
      defAutoClose = WARNING_AUTO_CLOSE
    } else {
      defAutoClose = SUCCESS_AUTO_CLOSE
    }
  }

  const position = loadToastPosition()

  return RtToast[type](<ToastContent title={title} subTitle={subTitle} customContent={customContent} />, {
    autoClose: defAutoClose,
    position: position,
    hideProgressBar: true,
    closeOnClick: closeOnClick,
    pauseOnHover: true,
    draggable: draggable,
    progress: undefined,
    theme: theme,
    icon: showIcon,
  })
}

export default Toast
